import { render, staticRenderFns } from "./UploadResumeBanner.vue?vue&type=template&id=bd2cbc20&scoped=true&"
import script from "./UploadResumeBanner.vue?vue&type=script&lang=js&"
export * from "./UploadResumeBanner.vue?vue&type=script&lang=js&"
import style0 from "./UploadResumeBanner.vue?vue&type=style&index=0&id=bd2cbc20&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd2cbc20",
  null
  
)

export default component.exports